// extracted by mini-css-extract-plugin
export default {"semiTitle":"item_semiTitle__ZFgPE","lineButtons":"item_lineButtons__tiGyp","headers":"item_headers__CvrYi","twoInLine":"item_twoInLine__7GTBc","blokInputs":"item_blokInputs__spFFn"};